import script from "./ProfileCompletion.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCompletion.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCompletion.vue?vue&type=style&index=0&id=709db6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709db6c0"]])

export default __exports__